import { useTranslation } from 'react-i18next'
import { Callout } from '@/shared/components/cse'
import { formatIsoDateTimeDisplay } from '@/shared/lib/datetime'

export function SettlementPendingNote({
  deadlineAt,
  className,
}: {
  deadlineAt?: string | null
  className?: string
}) {
  const { t } = useTranslation()

  return (
    <Callout tone="brand" title={t('ui.settlement_pending.title')} className={className}>
      <p>{t('ui.settlement_pending.body')}</p>
      {deadlineAt ? (
        <p>{t('ui.settlement_pending.deadline', { date: formatIsoDateTimeDisplay(deadlineAt) })}</p>
      ) : null}
    </Callout>
  )
}
